export const COLOR_DEFAULT_LIST = [
    '#ffffff',
    '#e4e4e4',
    '#a8a8a8',
    '#000000',
    '#4b5563',
    '#dc2625',
    '#f77171',
    '#fee2e3',
    '#d97709',
    '#fbbf26',
    '#fef3c7',
    '#009669',
    '#31d399',
    '#d1fae5',
    '#00989e',
    '#5be1e6',
    '#b3f7f9',
    '#2663eb',
    '#60a5fa',
    '#dbeafe',
    '#7e38ed',
    '#a78bfa',
    '#ede9fe',
];
